<script lang="ts">
  import type { Map } from "leaflet";
  import { getContext, onDestroy, onMount } from "svelte";

  const { getMap } = getContext("map");
  const map: Map = getMap();

  let zoomInDisabled: boolean = false;
  let zoomOutDisabled: boolean = false;

  onDestroy(() => {
    map.off("zoomend zoomlevelschange", handleZoomEnd);
  });
  onMount(() => {
    map.on("zoomend zoomlevelschange", handleZoomEnd);
  });

  const handleZoomEnd = () => {
    const zoom: number = map.getZoom();
    zoomInDisabled = zoom === map.getMaxZoom();
    zoomOutDisabled = zoom === map.getMinZoom();
  };

  const handleZoomIn = (event: MouseEvent) => {
    if (map.getZoom() < map.getMaxZoom()) {
      map.zoomIn(map.options.zoomDelta * (event.shiftKey ? 3 : 1));
    }
  };

  const handleZoomOut = (event: MouseEvent) => {
    if (map.getZoom() > map.getMinZoom()) {
      map.zoomOut(map.options.zoomDelta * (event.shiftKey ? 3 : 1));
    }
  };
</script>

<div class="container">
  <button
    aria-hidden="true"
    class="btn btn-light btn-sm"
    disabled={zoomInDisabled}
    on:click={handleZoomIn}
    title="Zoom inn"
    type="button">+</button
  >
  <button
    aria-hidden="true"
    class="btn btn-light btn-sm"
    disabled={zoomOutDisabled}
    on:click={handleZoomOut}
    title="Zoom ut"
    type="button">&#x2212;</button
  >
</div>

<style>
  .container {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 16px;
    top: 96px;
  }
  .container > * {
    margin-top: 0.25rem;
  }
  .container > *:first-child {
    margin-top: 0;
  }
</style>
